import { URL_PATH_ES } from 'constants/multiLanguage';
import { ONB_ROBO_PATH } from 'constants/onboardingTypesPaths';
import { ONB_BANK_DEPOSIT_OPEN, ONB_BANK_ACCOUNT_OPEN, ONB_ROBO } from 'constants/onboardingTypes';
import { TRADITIONAL } from 'constants/userProfile';

const StringHelper = require('utilities/stringHelper');

export const sanetizeUrl = path => path.replace(URL_PATH_ES, '').replace(/\/$/, '').replace(/^\//, '');

export const identifyOnboardingTypeByPath = value => {
    const sanetizedPath = sanetizeUrl(value);
    const onboardingTypePaths = {
        [ONB_ROBO_PATH]: ONB_ROBO,
    };

    return onboardingTypePaths[sanetizedPath] || ONB_BANK_ACCOUNT_OPEN;
};

export const getFieldDocsByOnbType = onbType => {
    const onbTypeClean = StringHelper.stringReplaceAll(onbType.toLowerCase(), '_', '').substring(3);

    return onbType ? `field-docs_${onbTypeClean}` : '';
};

export const isDeposit = ({ investmentType, onboardingType }) => {
    return investmentType === TRADITIONAL && onboardingType === ONB_BANK_DEPOSIT_OPEN;
};
